import { get } from "svelte/store";
import { auth } from "./firebase";
import { signInAnonymously } from "firebase/auth";
import axios from "./axios";
import { setAxiosAuthToken, clearAxiosAuthToken } from "./axios";
import { isLoggedIn, isCurrentUserLoaded, currentUserStore } from "../store/store-user";
import { isFunction } from "./utils";
/**
 * Call api with Firebase anonymous account token
 * @param callback An api call
 */
export async function callApiWithAnonymousAuth(callback, config = {}) {
    // Do nothing if user has already login or Firebase Auth not init yet
    if (!get(isCurrentUserLoaded) || get(isLoggedIn))
        return;
    let user;
    let res;
    try {
        const userCredential = await signInAnonymously(auth);
        user = userCredential.user;
        setAxiosAuthToken(await user.getIdToken());
        res = await callback();
    }
    catch (error) {
        // console.log("Call api with anonymous account error: ", error);
        const apiError = {
            key: "",
            message: "Server is unreachable. Please try again in a few minutes."
        };
        if (isFunction(config.onError))
            config.onError(apiError);
    }
    if (user) {
        await user.delete();
        clearAxiosAuthToken();
    }
    return res;
}
/**
 * Handle error from calling axios request
 * @param error
 * @param config
 */
export function handleError(error, config) {
    console.log("Error: ", error);
    // console.log("Error status: ", error.status);
    if (error.response) {
        // Handle for too many request error
        if (error.response.status === 429 &&
            isFunction(config.onTooManyRequest)) {
            return config.onTooManyRequest(error);
        }
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // in case no onTooManyRequest handler, fallback to use onRequestError
        if (isFunction(config.onRequestError))
            return config.onRequestError(error);
    }
    else if (error.request) {
        // The request was made but no response was received
        if (isFunction(config.onNoResponseError))
            return config.onNoResponseError(error);
    }
    else {
        // Something happened in setting up the request that triggered an Error
        // console.log('Error', error.message);
        if (isFunction(config.otherError))
            return config.otherError(error);
    }
}
export async function axiosCall(requestConfig, callbackConfig) {
    try {
        const res = await axios(requestConfig);
        if (callbackConfig && isFunction(callbackConfig.onSuccess))
            await callbackConfig.onSuccess(res.data);
        return res.data;
    }
    catch (error) {
        if (callbackConfig && isFunction(callbackConfig.onError))
            await callbackConfig.onError(error);
    }
}
export const USER_EMAIL_HEADER_KEY = "x-dd-useremail";
export const USER_ID_HEADER_KEY = "x-dd-userid";
export const USER_GROUP_HEADER_KEY = "x-dd-usergroup";
export function createHeader(data = {}) {
    const currentUser = get(currentUserStore);
    const header = {};
    // add user email header
    if (data.email)
        header[USER_EMAIL_HEADER_KEY] = data.email;
    // add user id header
    if (currentUser && currentUser.uid)
        header[USER_ID_HEADER_KEY] = currentUser.uid;
    return header;
}
